import Datatable from './datatable.vue';

export default Datatable;


// WEBPACK FOOTER //
// ./src/components/datatable/index.js